export default __webpack_public_path__ + "static/media/ARVP_Logo.7cee2734.png";